//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import _ from 'lodash'
import { getToken } from '@/utils/storage'
import Pagination from './components/pagination'
import tools from './components/tools'
import search from './components/search'
export default {
  name: 'tableUnit',
  components: {
    tools,
    search,
    Pagination
  },
  props: {
    config: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      header: {
        'X-token': getToken()
      },
      tableConfig: this.config,
      tableList: [],
      showSearch: false,
      landscape: true,
      columnsShow: this.config.columns
    }
  },
  // cumputed: {
  //   copyConfig () {
  //     let height = this.$refs.tableWrap.$el.clientHeight
  //     console.log(height)
  //     return this.config
  //   }
  // },
  created () {
    this.checkError()
  },
  mounted () {
    this.getTableList()
  },
  mounted () {
    this.getTableList()
  },
  methods: {
    checkError () {
      if (!this.config.api) {
        console.error('config.api is required')
      }
      if (!this.config.columns) {
        console.error('config.columns is required')
      }
    },
    checkChange (val) {
      this.columnsShow = this.tableConfig.columns.filter(i => val.indexOf(i.label) >= 0)
    },
    getTableList (searchData, paginationData, isSearch) {
      searchData = searchData || (this.$refs.search && this.$refs.search.getData()) || {}
      paginationData = paginationData || (this.$refs.pagination && this.$refs.pagination.getData()) || {}
      let formatPaginationData = {}
      if (paginationData) {
        formatPaginationData = {
          limit: paginationData.pageSize,
          page: paginationData.currentPage
        }
      }
      let postData = {}
      if (isSearch) {
        postData = searchData
      } else {
        postData = {
          ...formatPaginationData,
          ...searchData
        }
      }
      this.config.api(postData).then(res => {
        if (res.data.code === '200') {
          if (this.config.tools && this.config.tools.pagination) {
            this.tableList = res.data.data.rows
            this.$set(this.config.tools.pagination.pageParams, 'total', res.data.data.total)
            this.$emit('refreshTable', this.tableList, res.data.data.total)
          } else {
            this.tableList = res.data.data
            this.$emit('refreshTable', this.tableList)
          }
        }
      })
    },
    selectionChange (val) {
      this.$emit('selectionChange', val)
    },
    // 导入成功
    importSuccess (response, file, fileList) {
      if (response.code === 200) {
        this.$message({
          message: '导入成功',
          type: 'success'
        })
        this.search()
      } else {
        this.$message({
          message: response.msg,
          type: 'warning'
        })
      }
    },
    // 导入失败
    importFaild (err, file, fileList) {
      this.$message({
        message: err,
        type: 'warning'
      })
    },
    // 导出
    exportAsset (exportApi) {
      let data = this.$refs.search && this.$refs.search.getData()
      exportApi(data).then(res => {
        // console.log('---- res: ', res.headers)
        // let fileName = res.headers['content-disposition'] && res.headers['content-disposition'].split(';')[1].split('filename=')[1]
        // console.log(res.data);
        let blob = new Blob([res.data])
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '资产列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
    },
    pageChange (pagination) {
      this.getTableList(null, pagination)
      this.$emit('changePage', pagination)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tableUnit/index.vue